import DatePicker from '../components/generic/form/DatePicker';
import DatePickerAvailabilities from '../components/generic/form/DatePickerAvailabilities';
import DateRangePicker from '../components/generic/form/DateRangePicker';

export const isDateRangePickerFilter = filterType => filterType === DateRangePicker;
export const isDatePickerFilter = filterType =>
  filterType === DatePicker || filterType === DatePickerAvailabilities || isDateRangePickerFilter(filterType);
